import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home.js';
import Login from './pages/Login.js';
import DashboardLayout from './components/DashboardLayout.js';
import Farmers from './pages/Dashboard/Farmers.js';
import Users from './pages/Dashboard/Users.js';
import AboutUs from './pages/AboutUs.js';
import DashBoard from './pages/Dashboard/Dashboard.js';
import Products from './pages/Dashboard/Products.js';
import Settings from './pages/Dashboard/Settings.js';
import CollectionRoutes from './pages/Dashboard/CollectionRoutes.js';
import FarmerUpdate from './pages/Dashboard/FarmerUpdate.js';
import FarmerView from './pages/Dashboard/FarmerView.js';
import ProductUpdate from './pages/Dashboard/ProductForm.js';
import ProductView from './pages/Dashboard/ProductView.js';
import Profile from './pages/Dashboard/Profile.js';
import ProfileUpdate from './pages/Dashboard/ProfileUpdate.js';
import UserView from './pages/Dashboard/UserView.js';
import LogOut from './components/LogOut.js';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import TermsAndConditions from './pages/TermsAndConditions.js';
import ProtectedRoute from './utils/ProtectedRoute.js';
import UnAuthorised from './pages/UnAuthorized.js';
import ForgotPassword from './pages/ForgotPassword.js';
import EmailConfirmation from './pages/EmailConfirmation.js';
import PasswordReset from './pages/PasswordReset.js';
import Error404 from './pages/Error404.js';
import DashPasswordReset from './pages/Dashboard/DashPasswordReset.js';
import MilkPrices from './pages/Dashboard/MilkPrices.js';
import MilkCollectionForm from './pages/Dashboard/MilkCollectionForm.js';
import Debts from './pages/Dashboard/Debts.js';
import DebtForm from './pages/Dashboard/DebtForm.js';
import MilkCollections from './pages/Dashboard/MilkCollectionList.js';
import PaymentPeriods from './pages/Dashboard/PaymentPeriods.js';
import Payments from './pages/Dashboard/Payments.js';
import DebtView from './pages/Dashboard/DebtView.js';
import UserForm from './pages/Dashboard/UserForm.js';
import PaymentSummary from './pages/Dashboard/PaymentSummary.js';
import PaymentsByRoute from './pages/Dashboard/PaymentsByRoute.js';
import Aggregations from './pages/Dashboard/Aggregations.js';
import AggregationForm from './pages/Dashboard/AggregationForm.js';
import MilkSales from './pages/Dashboard/MilkSales.js';
import MilkSaleForm from './pages/Dashboard/MilkSaleForm.js';
import MilkSaleDetails from './pages/Dashboard/MilkSaleDetails.js';
import DebtRepayments from './pages/Dashboard/DebtRepayments.js';
import DebtRepaymentForm from './pages/Dashboard/DebtRepaymentForm.js';
import DebtRepaymentView from './pages/Dashboard/DebtRepaymentView.js';
import Expenses from './pages/Dashboard/Expenses.js';
import ExpenseView from './pages/Dashboard/ExpenseView.js';
import ExpenseForm from './pages/Dashboard/ExpenseForm.js';

function App() {
  return (
    <Router>
      <Routes>
        {/* Unprotected routes */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/account/email-confirmation" element={<EmailConfirmation />} />
        <Route path="/account/forgot-password" element={<ForgotPassword />} />
        <Route path="/account/password-reset" element={<PasswordReset />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/logout" element={<LogOut />} />
        <Route path="/un-authorized" element={<UnAuthorised />} />

        {/* Protected dashboard routes */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route
            path=""
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <DashBoard />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/:id/details"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <UserView />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/add"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <UserForm />
              </ProtectedRoute>
            } />
          <Route
            path="users/:id/update"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <UserForm />
              </ProtectedRoute>
            } />
          <Route
            path="farmers"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <Farmers />
              </ProtectedRoute>
            }
          />
          <Route
            path="farmers/add"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin', 'user']}>
                <FarmerUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="farmers/:id/update"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin', 'user']}>
                <FarmerUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="farmers/:id/details"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <FarmerView />
              </ProtectedRoute>
            }
          />
          <Route
            path="milk-collections"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <MilkCollections />
              </ProtectedRoute>
            }
          />
          <Route
            path="debts"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <Debts />
              </ProtectedRoute>
            }
          />

          <Route
            path="debt-repayments"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <DebtRepayments />
              </ProtectedRoute>
            }
          />
          <Route
            path="debt-repayments/add"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <DebtRepaymentForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="debt-repayments/:id/details"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <DebtRepaymentView />
              </ProtectedRoute>
            }
          />

          <Route
            path="payment-periods"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <PaymentPeriods />
              </ProtectedRoute>
            }
          />
          <Route
            path="payment-periods/:id/details"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <Payments />
              </ProtectedRoute>
            }
          />

          <Route path="payment-periods/:periodId/route/:routeId"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <PaymentsByRoute />
              </ProtectedRoute>
            }
          />

          <Route path="payment-periods/:periodId/payments"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <PaymentsByRoute />
              </ProtectedRoute>
            }
          />

          <Route
            path="payment-periods/:periodId/summary"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <PaymentSummary />
              </ProtectedRoute>
            }
          />
          <Route
            path="milk-collections/add"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <MilkCollectionForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="milk-collections/:id/update"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <MilkCollectionForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="debts"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <Debts />
              </ProtectedRoute>
            }
          />
          <Route
            path="debts/add"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <DebtForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="debts/:id/update"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <DebtForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="debts/:id/details"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <DebtView />
              </ProtectedRoute>
            }
          />
          <Route
            path="products"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path="products/:id/update"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <ProductUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="products/add"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <ProductUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="products/:id/details"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <ProductView />
              </ProtectedRoute>
            }
          />
          <Route
            path="collection-routes"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <CollectionRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="milk-prices"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <MilkPrices />
              </ProtectedRoute>
            } />
          <Route
            path="profile"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin', 'aggregator']}>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile/update"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <ProfileUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile/reset-password"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin', 'aggregator']}>
                <DashPasswordReset />
              </ProtectedRoute>
            } />

          <Route
            path="aggregations"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <Aggregations />
              </ProtectedRoute>
            }
          />
          <Route
            path="aggregations/add"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <AggregationForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="aggregations/:id/update"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <AggregationForm />
              </ProtectedRoute>
            }
          />

          <Route
            path="milk-sales"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <MilkSales />
              </ProtectedRoute>
            }
          />

          <Route
            path="milk-sales/add"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <MilkSaleForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="milk-sales/:id/update"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <MilkSaleForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="milk-sales/:id/details"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <MilkSaleDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="expenses"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <Expenses />
              </ProtectedRoute>
            }
          />
          <Route
            path="expenses/:id/details"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <ExpenseView />
              </ProtectedRoute>
            }
          />
          <Route
            path="expenses/add"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <ExpenseForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="expenses/:id/update"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'aggregator']}>
                <ExpenseForm />
              </ProtectedRoute>
            }
          />

        </Route>
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
